import styled from "styled-components";

interface TitleProps {
  title?: string | null;
  hasSpacing?: boolean;
}

export function Title({ title, hasSpacing = false }: TitleProps) {
  const hasOnlySpacer = !title && hasSpacing;
  
  return (
    <Content>
      {title && (
        <Text>
          <span>
            {title}
            {hasSpacing && <Spacer />}
          </span>
        </Text>
      )}
      {hasOnlySpacer && <Spacer />}
    </Content>
  );
}

const Content = styled.div`
  padding: 64px 0;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 16px 0;
  }
`;

const Text = styled.h2`
  color: ${({ theme }) => theme.colors.blue.dark};
  text-transform: uppercase;
  text-align: center;
  font-size: 36px;

  span {
    display: inline-block;
  }

  hr {
    width: 60px;
    margin-top: 8px;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 26px;
  }
`;

const Spacer = styled.hr`
  max-width: 592px;
  height: 8px;
  margin: auto;
  border: none;
  background-color: ${({ theme }) => theme.colors.pink.light};

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: none;
  }
`;